import { brandLogos } from './brandLogos'

// Replace various symbols with underscores
const getLogoName = (name: string) =>
  name?.toLowerCase().replace(/\s|\/|\.|'|`|’/g, '_') ?? ''

export const getBrandLogoPath = (brand: string) => {
  return brandLogos[getLogoName(brand)]
}
